import styled from '@emotion/styled'

import { Spacing } from '../../../../enums/spacing'
import { NavListItem } from '../../elements/NavListItem'

interface SuffixWrapperProps {
  shouldShowSuffixOnHover?: boolean
}

export const SuffixWrapper = styled.span<SuffixWrapperProps>`
  display: ${({ shouldShowSuffixOnHover }) => (shouldShowSuffixOnHover ? 'none' : 'flex')};
  flex-shrink: 0;
  margin-left: auto;
  padding-left: ${Spacing.S8};

  svg,
  path {
    stroke: currentColor;
  }
`

export const NavListItemWithBlockDescription = styled(NavListItem)`
  height: auto;

  &:hover {
    ${SuffixWrapper} {
      display: block;
    }
  }
` as typeof NavListItem

export const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`

export const Content = styled.div`
  flex: 1;

  /* a hack to truncate text in flexbox 
  https://css-tricks.com/flexbox-truncated-text/
  */
  min-width: 0;
`

export const TextWrapper = styled.div`
  display: flex;
  align-items: center;
`
